import React, { Component } from "react";
import { GetUserInfoProps, withGetUserInfo } from "../../graphql/components";
import LoadingCabecalho from "../Loading/LoadingCabecalho";
import { List, ListItem, ListItemText } from "@material-ui/core";
import { Tooltip, Typography, Button } from "@material-ui/core";
import PapperBlock from "../PapperBlock/PapperBlock";
import { withStyles } from "@material-ui/core/styles";
import { cor } from "../../styles/theme/paletaCores";

interface Props {
  classes?: any;
}

interface IState {
  errors?: boolean;
  loading?: boolean;
  data: any;
  arrowRef: any;
}

export const estiloSaudacao: React.CSSProperties = {
  margin: 0,
  textTransform: "none",
  color: cor("azul"),
  fontFamily: "Roboto, sans-serif",
  fontSize: 24,
  fontWeight: 800,
  width: "100%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};

const styles = (theme: any) => ({
  lightTooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.93)",
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
});

export class DadosUsuario extends Component<GetUserInfoProps<Props>, IState> {
  saudacao = () => {
    const hora = new Date().getHours();
    if (hora < 12) {
      return "Bom dia";
    }
    if (hora < 18) {
      return "Boa tarde";
    }
    return "Boa noite";
  };

  userInfo = (fullName: String) => {
    return (
      <PapperBlock title="Informações do usuário" icon="ios-trending-up">
        <List>
          <ListItem alignItems="flex-start">
            <ListItemText
              primary="Nome Completo"
              secondary={
                <React.Fragment>
                  <Typography component="span" color="textPrimary">
                    {fullName}
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        </List>
      </PapperBlock>
    );
  };

  render() {
    if (this.props.data!.loading) {
      return <LoadingCabecalho />;
    } else if (this.props.data && this.props.data.getUserInfo) {
      return (
        <React.Fragment>
          <Tooltip
            classes={{ tooltip: this.props.classes.lightTooltip }}
            title={this.userInfo(this.props.data!.getUserInfo!.fullName!)}
          >
            <Button size="small" style={{ padding: 0, maxWidth: "100%" }}>
              <div style={estiloSaudacao}>
                {this.saudacao()},{" "}
                <span style={{ textTransform: "capitalize" }}>
                  {this.props.data!.getUserInfo!.nomeAbreviado!.toString().toLowerCase()}
                </span>
                !
              </div>
            </Button>
          </Tooltip>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}

const withGetUserInfoMutation = withGetUserInfo({});

const DadosUsuarioEnhanced = withGetUserInfoMutation(DadosUsuario);

export default withStyles(styles as any)(DadosUsuarioEnhanced);
